import React, { useState, useEffect } from 'react';
import './splitFlap.css';

export function SplitFlapDigit({ value }) {
    const [displayValue, setDisplayValue] = useState({
        current: value,
        next: value,
    });
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (value !== displayValue.current && !isAnimating) {
            setDisplayValue(prev => ({ current: prev.current, next: value }));
            setIsAnimating(true);
        }
    }, [value, displayValue.current, isAnimating]);

    const handleAnimationEnd = () => {
        setDisplayValue({
            current: displayValue.next,
            next: displayValue.next,
        });
        setIsAnimating(false);
    };

    return (
        <div className={`split-flap ${isAnimating ? 'animating' : ''}`}>
            {/* Upper static half */}
            <div className="flap top">
                <span>{displayValue.next}</span>
            </div>

            {/* Lower static half */}
            <div className="flap bottom">
                <span>{displayValue.current}</span>
            </div>

            {/* Animated falling top leaf */}
            <div className="flap leaf-top">
                <span>{displayValue.current}</span>
            </div>

            {/* Animated falling bottom leaf */}
            <div
                className="flap leaf-bottom"
                onAnimationEnd={handleAnimationEnd}
            >
                <span>{displayValue.next}</span>
            </div>
        </div>
    );
}
